interface ListeRefnasodafJson {
    categoryCode: string;
    code: string;
    libelle: string;
}

export class ListeRefnasodaf {
    categoryCode: string;
    code: string;
    libelle: string;

    constructor(input: ListeRefnasodafJson) {
        this.categoryCode = input.categoryCode;
        this.code = input.code
        this.libelle = input.libelle;
     }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/liste-refnasodaf.model.ts